import { createTheme, type ThemeOptions } from '@mui/material';
import { breakpoints } from './values/breakpoints';
import { colorSchemes } from './values/colorSchemes';
import { components } from './values/components';
import { shape } from './values/shape';
import { spacing } from './values/spacing';
import { typography } from './values/typography';

export const themeOptions: ThemeOptions = {
  breakpoints,
  typography,
  components,
  shape,
  spacing,
  defaultColorScheme: 'v4',
  colorSchemes,
};

export const v4 = createTheme(themeOptions);
export type V4Theme = typeof v4;
